/**
 * @generated SignedSource<<2a2ca5d6fc37985a9362b546689a639c>>
 * @relayHash 78396ab35b11952b3d1e9cfd21709c04
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cdbbfd1006a333a663e7ae48d6031ff80a508528f1a4bf6910329f857ed2d3bc

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraJqlViewContext = "JPD_ROADMAPS" | "JSM_SUMMARY_PAGE" | "JSW_PLANS" | "JSW_SUMMARY_PAGE" | "JWM" | "SHADOW_REQUEST" | "%future added value";
export type issueTypeJqlBuilderBasicFieldValuesQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  first?: number | null | undefined;
  jql: string;
  jqlTerm: string;
  searchString: string;
  viewContext?: JiraJqlViewContext | null | undefined;
};
export type issueTypeJqlBuilderBasicFieldValuesQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly fieldValues: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly issueTypes?: ReadonlyArray<{
              readonly avatar: {
                readonly xsmall: string | null | undefined;
              } | null | undefined;
            }>;
            readonly jqlTerm: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
        };
        readonly totalCount: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type issueTypeJqlBuilderBasicFieldValuesQuery = {
  response: issueTypeJqlBuilderBasicFieldValuesQuery$data;
  variables: issueTypeJqlBuilderBasicFieldValuesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jqlTerm"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewContext"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "jqlContext",
    "variableName": "jql"
  },
  {
    "kind": "Variable",
    "name": "jqlTerm",
    "variableName": "jqlTerm"
  },
  {
    "kind": "Variable",
    "name": "searchString",
    "variableName": "searchString"
  },
  {
    "kind": "Variable",
    "name": "viewContext",
    "variableName": "viewContext"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v10 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v12 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v13 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "issueTypeJqlBuilderBasicFieldValuesQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v7/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v8/*: any*/),
                  "concreteType": "JiraJqlFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "fieldValues",
                  "plural": false,
                  "selections": [
                    (v9/*: any*/),
                    (v10/*: any*/),
                    {
                      "concreteType": "JiraJqlFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v11/*: any*/),
                            (v12/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraIssueType",
                                  "kind": "LinkedField",
                                  "name": "issueTypes",
                                  "plural": true,
                                  "selections": [
                                    (v13/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraJqlIssueTypeFieldValue"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "issueTypeJqlBuilderBasicFieldValuesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v8/*: any*/),
                "concreteType": "JiraJqlFieldValueConnection",
                "kind": "LinkedField",
                "name": "fieldValues",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "concreteType": "JiraJqlFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueTypes",
                                "plural": true,
                                "selections": [
                                  (v13/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "id"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlIssueTypeFieldValue"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "cdbbfd1006a333a663e7ae48d6031ff80a508528f1a4bf6910329f857ed2d3bc",
    "metadata": {},
    "name": "issueTypeJqlBuilderBasicFieldValuesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "21ba82206daeda54945442d24f7c39ff";

export default node;
